import React from "react";
import {Form, Icon, Input, Button, Row, Col, notification, Select, Checkbox} from "antd";
import {Redirect} from "react-router-dom";
import {AppContext} from "../../../contexts/app-context";
import Spinner from "../../spinner";
import {userServices} from "../../../services";
import ShowTerms from "../../modals/show-terms";
import Banner from "../../banner";
import ShowOffer from "../../modals/show-offer";
import ShowTermsOfUse from "../../modals/terms-of-use";
import ModalDeactiveUser from "../../modals/user/deactive-user.js";
import i18n from "../../../i18n";

class RegisterPage extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      successful: false,
      fieldsErrors: [],
      redirectToLogin: false,
      history: null,
      isShowModalTerms: false,
      isShowModalTermsOfUse: false,
      isShowModalOffer: false,
      isTermsAgreed: false,
      isTermsOfUseAgreed: false,
      isOfferAgreed: false,
      isButtonEnabled: false,
      message: '',
      approvePhoneVisible: false,
      isShowDeactiveUserModal: false,

      registerCountry: '1',
      phoneCode: '+7'
    };

    this.buttonStyle = {
      width: "100%",
      fontSize: "20px",
      height: "40px",
      backgroundColor: "#1CAA53",
      borderRadius: "7px"
    };

    this.approveNumberButton = {
      height: '43px',
      background: '#2b3f63',
      position: 'static',
      borderRadius: '10px',
      color: "white",
      borderColor: "transparent",
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '20px'
    };
  }

  onSubmitFormRegister = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });

        let countryId = this.state.registerCountry;
        let phone = values.phone;

        userServices
          .register({
            fio: values.fio,
            email: values.email,
            phone: phone,
            countryId: countryId,
            legalNumber: values.legalNumber
          })
          .then((data) => {
            if (data.status === 'success') {
              this.setState({
                successful: true,
                message: data.message,
              });
            } else {
              this.setState({
                fieldsErrors: data.errors
              });

              notification.warning({
                message: i18n.t(`registerPage.titles.main`),
                description: data.message.toString(),
              });

              if (data.errors && data.errors.phone_used) {
                this.setState({approvePhoneVisible: true});
              }
            }
          })
          .catch((errorMsg) => {
            notification.warning({
              message: i18n.t(`registerPage.titles.main`),
              description: errorMsg.toString(),
            });
          })
          .finally(() => {
            this.setState({
              loading: false,
            });
          });
      }
    });
  };

  loginBtnAction = () => {
    this.setState({
      redirectToLogin: true,
    });
  };

  render() {
    this.user = userServices.getUser();

    if (this.user.loggedIn) {
      return <Redirect to="/"/>;
    }

    if (this.state.redirectToLogin) {
      return <Redirect to="/login"/>;
    }

    if (this.context.filter.enable) {
      this.context.disableFilter();
    }

    const {getFieldDecorator} = this.props.form;

    const getFieldStatus = fieldName => {
      return (this.state.fieldsErrors && typeof this.state.fieldsErrors[fieldName] !== "undefined")
        ? 'error'
        : 'success';
    };

    const getFieldHelp = fieldName => {
      return (this.state.fieldsErrors && typeof this.state.fieldsErrors[fieldName] !== "undefined")
        ? this.state.fieldsErrors[fieldName][0]
        : '';
    };

    const setCountryPhone = (value, data) => {
      this.state.phoneCode = value;
      this.state.registerCountry = data.key;
    };

    const setButtonEnabled = () => {
      const vals = this.props.form.getFieldsValue(['fio', 'email', 'phone']);
      if (!Boolean(Object.values(vals).filter((item) => item === undefined).length)) {
        this.setState({
          isButtonEnabled: true,
        });
      } else {
        this.setState({
          isButtonEnabled: false,
        });
      }
    };

    // оферта
    const setIsShowOffer = (val) => {
      this.setState({
        isShowModalOffer: val,
      });
      setButtonEnabled();
    }

    const setIsOfferAgreed = (val) => {
      this.setState({
        isOfferAgreed: val,
      });
      setButtonEnabled();
    }

    const handleLinkClick = (evt) => {
      evt.preventDefault();
      setIsShowOffer(true);
    }

    const handleOfferCheckboxChange = () => {
      setIsOfferAgreed(!this.state.isOfferAgreed);
      setButtonEnabled();
    };

    const setShowDeactiveModal = (val) => {
      this.setState({
        isShowDeactiveUserModal: true,
      });
      console.log(this.state.isShowDeactiveUserModal);
    }


    // пользовательское соглашение
    const setIsShowTermsOfUse = (val) => {
      this.setState({
        isShowModalTermsOfUse: val,
      });
      setButtonEnabled();
    }
    const setIsTermsOfUseAgreed = (val) => {
      this.setState({
        isTermsOfUseAgreed: val,
      });
      setButtonEnabled();
    }
    const handleTermsOfUseLinkClick = (evt) => {
      evt.preventDefault();
      setIsShowTermsOfUse(true);
    }
    const handleTermsOfUseCheckboxChange = () => {
      setIsTermsOfUseAgreed(!this.state.isTermsOfUseAgreed);
      setButtonEnabled();
    };

    // политика обработки
    const setIsShowTerms = (val) => {
      this.setState({
        isShowModalTerms: val,
      });
      setButtonEnabled();
    }

    const setIsTermsAgreed = (val) => {
      this.setState({
        isTermsAgreed: val,
      });
      setButtonEnabled();
    }

    const handleCheckboxChange = () => {
      setIsTermsAgreed(!this.state.isTermsAgreed);
      setButtonEnabled();
    };

    const handleTermsLinkClick = (evt) => {
      evt.preventDefault();
      setIsShowTerms(true);
    }

    return (
      <Spinner loading={this.state.loading} label={i18n.t(`main.loadText.loading`)}>
        <div className="container">
          <Row>
            <Col className="register-page-content">
              <h1>{this.state.successful ? i18n.t(`registerPage.titles.success`) : i18n.t(`registerPage.titles.main`)}</h1>
              {this.state.successful ? (
                <>
                  <div className="register-success">{this.state.message}
                  </div>
                  <Button style={this.buttonStyle} type="primary" htmlType="submit" className="login-form-button"
                          onClick={() => this.loginBtnAction()}>
                    {i18n.t(`registerPage.form.buttons.submit`)}
                  </Button>
                </>
              ) : (
                <Form onSubmit={this.onSubmitFormRegister} className="register-form">
                  <Form.Item
                    validateStatus={getFieldStatus('fio')}
                    help={getFieldHelp('fio')}
                  >
                    {getFieldDecorator("fio", {
                      rules: [{required: true, message: i18n.t(`registerPage.form.name.error`)}],
                      initialValue: this.state.username,
                    })(<Input size="large" prefix={<Icon type="user" style={{color: "rgba(0,0,0,.25)"}}/>}
                              onBlur={setButtonEnabled} placeholder={i18n.t(`registerPage.form.name.placeholder`)}/>)}
                  </Form.Item>
                  <Form.Item
                    validateStatus={getFieldStatus('email')}
                    help={getFieldHelp('email')}
                  >
                    {getFieldDecorator("email", {
                      rules: [{required: true, message: i18n.t(`registerPage.form.email.error`)}],
                      initialValue: this.state.username,
                    })(<Input size="large" onBlur={setButtonEnabled}
                              prefix={<Icon type="mail" style={{color: "rgba(0,0,0,.25)"}}/>}
                              placeholder={i18n.t(`registerPage.form.email.placeholder`)}/>)}
                  </Form.Item>

                <Select defaultValue={'+7'} onChange={setCountryPhone} size="large" style={{
                  width: "14%",
                  fontFamily: "Montserrat",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  fontSize: "13px",
                  lineHeight: "12px",
                  color: "black"
                }}>
                  <Select.Option key={1}>+7<img src="https://dota2.ru/img/flags/ru.png" alt="РФ"/></Select.Option>
                  <Select.Option key={3}>+375 <img src="https://dota2.ru/img/flags/by.png" alt="РБ"/></Select.Option>
                  <Select.Option key={6}>+7<img src="https://dota2.ru/img/flags/kz.png" alt="КЗ"/></Select.Option>
                </Select>

                <Form.Item
                  validateStatus={getFieldStatus('phone')}
                  help={getFieldHelp('phone')}
                  style={{width: "86%", float: "right"}}
                >
                  {getFieldDecorator("phone", {
                    rules: [{required: true, message: i18n.t(`registerPage.form.phone.error`)}],
                  })(
                    <Input size="large" prefix={<Icon type="phone" style={{color: "rgba(0,0,0,.25)"}}/>}
                           onBlur={setButtonEnabled} placeholder={i18n.t(`registerPage.form.phone.placeholder`)}/>
                  )}
                </Form.Item>

                  {this.state.approvePhoneVisible ? (
                    <Form.Item>
                      <Button
                        style={this.approveNumberButton}
                        htmlType="button"
                        type="primary"
                        onClick={setShowDeactiveModal}
                        key="get-codes"
                      >
                        {i18n.t(`registerPage.form.buttons.phone`)}
                      </Button>
                    </Form.Item>) : null}

                  <Form.Item
                    validateStatus={getFieldStatus('legalNumber')}
                    help={getFieldHelp('legalNumber')}
                  >
                    {getFieldDecorator("legalNumber", {
                      rules: [{required: true, message: i18n.t(`registerPage.form.legalNumber.error`)}],
                      initialValue: this.state.legalNumber,
                    })(<Input size="large" onBlur={setButtonEnabled}
                              prefix={<Icon type="solution" style={{color: "rgba(0,0,0,.25)"}}/>}
                              placeholder={i18n.t(`registerPage.form.legalNumber.placeholder`)}/>)}
                  </Form.Item>

                  <Form.Item
                    validateStatus={getFieldStatus('readTermsOfUse')}
                    help={getFieldHelp('readTermsOfUse')}
                  >
                    {getFieldDecorator("readTermsOfUse", {
                      rules: [{required: true, message: ""}],
                      initialValue: this.state.isTermsAgreed
                    })(
                      <Checkbox size="large"
                                onChange={handleTermsLinkClick}
                                checked={this.state.isTermsAgreed}
                                className="register-form-agree"
                      >
                        {i18n.t(`registerPage.form.agree.text.full`)}
                        <a href="#" onClick={handleTermsLinkClick}
                           className="link register-form-terms-link">
                          {i18n.t(`registerPage.form.agree.docs.doc1`)}
                        </a>
                      </Checkbox>
                    )}
                  </Form.Item>
                  <Form.Item
                    validateStatus={getFieldStatus('readOffer')}
                    help={getFieldHelp('readOffer')}
                  >
                    {getFieldDecorator("readOffer", {
                      rules: [{required: true, message: ""}],
                      initialValue: this.state.isOfferAgreed
                    })(
                      <Checkbox size="large"
                                onChange={handleLinkClick}
                                checked={this.state.isOfferAgreed}
                                className="register-form-agree"
                      >
                        {i18n.t(`registerPage.form.agree.text.shot`)}
                        <a href="" onClick={handleLinkClick}
                           className="link register-form-terms-link">
                          {i18n.t(`registerPage.form.agree.docs.doc2`)}
                        </a>
                      </Checkbox>
                    )}
                  </Form.Item>
                 
                  <Form.Item>
                    <Button type="primary" style={this.buttonStyle}
                            disabled={!this.state.isButtonEnabled || !this.state.isTermsAgreed || !this.state.isOfferAgreed }
                            htmlType="submit" className="register-form-button">
                      {i18n.t(`registerPage.form.buttons.register`)}
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={12}>
              {/*<GoogleAndroidAppLink />*/}
              <Banner banner={1}/>
            </Col>
            <Col xs={24} lg={12}>
              <Banner banner={2}/>
            </Col>
          </Row>
          <ShowTerms setIsShow={setIsShowTerms} setIsTermAgreed={setIsTermsAgreed}
                     isShow={this.state.isShowModalTerms}/>
          <ShowOffer setIsShow={setIsShowOffer} setIsOfferAgreed={setIsOfferAgreed}
                     isShow={this.state.isShowModalOffer}/>
          <ShowTermsOfUse setIsShow={setIsShowTermsOfUse} setIsTermOfUseAgreed={setIsTermsOfUseAgreed}
                          isShow={this.state.isShowModalTermsOfUse}/>
          <ModalDeactiveUser isShow={this.state.isShowDeactiveUserModal}
                             onCloseModal={() => this.setState({isShowDeactiveUserModal: false})}
                             phone={this.props.form.getFieldValue('phone')}/>
        </div>
      </Spinner>
    );
  }
}

export default Form.create({name: "normal_register"})(RegisterPage);
